<template>
    <ElPopover
        placement="bottom-start"
        width="330"
        :visible="popperVisible"
        popper-class="try-material-popper"
    >
        <div class="flex flex-col gap-2">
            <span class="text-sm font-semibold text-white">{{ t('TryMaterialTip')}}</span>
            <button
                class="rounded px-2 h-6 inline-flex items-center text-xs self-end bg-white"
                @click="openPopper(false)"
            >
                {{ t('GotIt') }}
            </button>
        </div>
        <template #reference>
            <button
                class="try-material-btn text-violet-900 rounded px-4 h-8 inline-flex items-center"
                @click="openOverview">
                {{ t('TryMaterial')}}
            </button>
        </template>
    </ElPopover>
</template>
<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import { ElPopover } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { cn, tw, en, jp } from './locales';
import { useBanner } from '@eureka/utils/banner';

const { t } = useI18n({
    fallbackLocale: 'cn',
    messages: {
        cn, tw, en, jp,
    },
});
const { bannerEvent, openOverview } = useBanner();
const popperVisible = ref(false);

function openPopper(value) {
    popperVisible.value = value;
}

onBeforeMount(async() => {
    bannerEvent.on('close', openPopper)
})
</script>
<style lang="scss">
.try-material-btn {
    background: linear-gradient(270deg, #E2DAFF 0%, #D0DEFE 100%);
    &:hover {
        background: linear-gradient(270deg, #C9BAFF 0%, #B2CBFF 100%);
    }
}
.try-material-popper {
    &.el-popover.el-popper {
        background: linear-gradient(270deg, #8D70F4 0%, #4D81F1 100%);
        border: 0;
    }
    &.el-popper[data-popper-placement^=bottom] .el-popper__arrow{
        width: 0;
        height: 0;
        &::before {
            transform: none;
            border: 0;
            top: -5px;
            background: transparent;
            border-left: 6px solid transparent !important;
            border-right: 6px solid transparent !important;
            border-bottom: 6px solid #8672F4 !important;
        }
    }
}
</style>
